import { render, staticRenderFns } from "./StarterFooter.vue?vue&type=template&id=174f61ba&scoped=true&"
import script from "./StarterFooter.vue?vue&type=script&lang=js&"
export * from "./StarterFooter.vue?vue&type=script&lang=js&"
import style0 from "./StarterFooter.vue?vue&type=style&index=0&id=174f61ba&prod&scoped=true&lang=css&"
import style1 from "./StarterFooter.vue?vue&type=style&index=1&id=174f61ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f61ba",
  null
  
)

export default component.exports